<form [formGroup]="addressForm" (ngSubmit)="onSubmit()">

  <ms-address-form formControlName="address" [required]="true" />

  <div class="d-flex justify-content-between align-items-center mt-4">
    <button type="button" class="btn btn-ms-secondary" (click)="onBack()">
      <fa-duotone-icon icon="chevron-left" secondaryOpacity="0.9" class="me-1"></fa-duotone-icon>
      Back
    </button>
    <div class="d-flex">
      <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
        @if (isSubmitting) {
          <div class="spinner-border text-light spinner-border-sm" role="status">
            <span class="visually-hidden">Saving...</span>
          </div>
        } @else {
          Save
        }
      </button>
    </div>
  </div>
</form>
